var SdgWheels = (function () {
  'use strict'

  var colors = ['#e5243b', '#dda63a', '#4c9f38', '#c5192d', '#ff3a21', '#26bde2', '#fcc30b', '#a21942', '#fd6925', '#dd1367', '#fd9d24', '#bf8b2e', '#3f7e44', '#0a97d9', '#56c02b', '#00689d', '#19486a']
  var xmlns = 'http://www.w3.org/2000/svg'
  var size = 500
  var cssPrefix = 'nsdg'

  function createSvg (cls, width, height) {
    if (!width) {
      width = size
    }
    if (!height) {
      height = size
    }
    var svg = document.createElementNS(xmlns, 'svg')
    svg.setAttribute('xmlns', xmlns)
    setSvgAttr(svg, 'class', cls)
    setSvgAttr(svg, 'viewBox', '0 0 ' + width + ' ' + height)
    setSvgAttr(svg, 'width', '100%')
    setSvgAttr(svg, 'height', '100%')

    return svg
  }

  function addSvgEl (parent, el) {
    return parent.appendChild(document.createElementNS(xmlns, el))
  }

  function setSvgAttr (el, attr, value) {
    el.setAttributeNS(null, attr, value)
  }

  var animateTranslateIntervals = []

  function animateTranslate (el, from, to, duration, done) {
    var stepDuration = 50
    var stepX = (to.x - from.x) / (duration * 1000 / stepDuration)
    var stepY = (to.y - from.y) / (duration * 1000 / stepDuration)
    var currentX = from.x
    var currentY = from.y

    var interval = animateTranslateIntervals.find(function (obj) {
      return obj.el === el
    })

    if (interval) {
      clearInterval(interval.func)
    } else {
      interval = {
        el: el,
        func: undefined
      }
      animateTranslateIntervals.push(interval)
    }

    interval.func = setInterval(function () {
      currentX += stepX
      currentY += stepY
      if (stepX > 0 ? currentX >= to.x : currentX <= to.x) {
        currentX = to.x
      }
      if (stepY > 0 ? currentY >= to.y : currentY <= to.y) {
        currentY = to.y
      }

      if (currentX === to.x && currentY === to.y) {
        clearInterval(interval.func)
        interval.func = undefined
        if (done) {
          done()
        }
      }
      setSvgAttr(el, 'transform', 'translate(' + currentX + ',' + currentY + ')')
    },
    stepDuration)
  }

  var animateAttrInterval = null
  function animateAttr (el, attr, end, duration) {
    var stepDuration = 20
    var current = parseFloat(el.getAttribute(attr))
    var step = (end - current) / (duration * 1000 / stepDuration)

    if (animateAttrInterval) {
      clearInterval(animateAttrInterval)
    }
    animateAttrInterval = setInterval(function () {
      current += step
      if (step > 0 ? current >= end : current <= end) {
        current = end
        clearInterval(animateAttrInterval)
      }
      setSvgAttr(el, attr, current)
    }, stepDuration)
  }

  function deg2Rad (d) {
    return d * Math.PI / 180
  }

  var Point = function (x, y) {
    this.x = x
    this.y = y
  }

  Point.fromCircle = function (c, a, r) {
    var rad = deg2Rad(a)

    return new Point(
      c + Math.cos(rad) * r,
      c + Math.sin(rad) * r
    )
  }

  function svgMoveTo (p) {
    return 'M' + p.x + ' ' + p.y
  }

  function svgLineTo (p) {
    return 'L' + p.x + ' ' + p.y
  }

  function svgArcTo (p, r, laf, sweep) {
    return 'A' + r + ' ' + r + ' 0 ' + laf + ' ' + sweep + ' ' + p.x + ' ' + p.y
  }

  function getSvgArc (c, r, h, w) {
    var deg = w / 2

    var A = Point.fromCircle(c, deg, r)
    var B = Point.fromCircle(c, deg, r + h)
    var C = Point.fromCircle(c, -deg, r + h)
    var D = Point.fromCircle(c, -deg, r)

    var laf = w > 180 ? 1 : 0

    return svgMoveTo(A) + svgLineTo(B) + svgArcTo(C, r + h, laf, 0) + svgLineTo(D) + svgArcTo(A, r, laf, 1) + 'Z'
  }

  function getSvgArrow (c, r, h, w) {
    var arrowHead = 5
    var deg = (w - arrowHead) / 2

    var A = Point.fromCircle(c, -deg, r)
    var B = Point.fromCircle(c, -deg, r + h)
    var C = Point.fromCircle(c, deg, r + h)
    var D = Point.fromCircle(c, deg, r)

    var laf = w > 180 ? 1 : 0

    var E = Point.fromCircle(c, deg, r + (4 * h / 5))
    var F = Point.fromCircle(c, deg + arrowHead, r + h / 2)
    var G = Point.fromCircle(c, deg, r + h / 5)

    return svgMoveTo(A) + svgLineTo(B) + svgArcTo(C, r + h, laf, 1) + svgLineTo(E) + svgLineTo(F) + svgLineTo(G) + svgLineTo(D) + svgArcTo(A, r, laf, 0) + 'Z'
  }

  /* NavWheel */

  var NavWheel = function (options) {
    this.settings = {
      mode: 'standard', // 'standard' | 'select' | 'target'
      name: null,
      goalHeight: 80,
      goalSelectedGap: 20,
      icons: false,
      showGoalsImmediately: true,
      showIconsImmediately: true,
      selectedGoals: [],
      disabledGoals: []
    }

    for (var key in this.settings) {
      if (options.hasOwnProperty(key)) {
        this.settings[key] = options[key]
      }
    }

    this.clipRect = undefined
    this.goals = []
    this.circle = undefined
    this.callbacks = []
    this.svg = undefined
    this.events = ['select', 'unselect']
    this.name = this.settings.name
    this.goalElements = []
    this.goalSelectedElements = []
  }

  NavWheel.prototype.on = function (event, cb) {
    var self = this

    if (!Array.isArray(event)) {
      event = [event]
    }

    event.forEach(function (e) {
      if (self.events.indexOf(e) > -1) {
        self.callbacks.push({ event: e, cb: cb })
      }
    })
  }

  NavWheel.prototype.trigger = function (event, goal) {
    var self = this

    var result = true

    this.callbacks.filter(function (e) {
      return e.event === event
    }).forEach(function (value) {
      var res

      if (self.events.indexOf(event) > -1) {
        res = value.cb({ event: event, goal: goal, id: parseInt(goal.getAttribute('data-goal')) })
      } else {
        res = value.cb({ event: event })
      }

      if (res === undefined || res === true) {
        result = result && true
      } else {
        result = false
      }
    })

    return result
  }

  NavWheel.prototype.getSvg = function () {
    var self = this

    this.svg = createSvg(cssPrefix + '-nav-wheel')

    var c = size / 2
    var h = this.settings.goalHeight
    var r = c - 20 - h - this.settings.goalSelectedGap
    var w = 360 / 17
    var s = (r + h) * 0.2
    var x = c + r + h + (s * 0.3)
    var y = c - s / 2

    if (this.settings.mode !== 'standard' && !this.settings.showIconsImmediately && this.settings.icons) {
      var defs = addSvgEl(this.svg, 'defs')
      var clip = addSvgEl(defs, 'clipPath')
      var clipId = cssPrefix + '-' + Math.random().toString(36).substr(2, 9)
      setSvgAttr(clip, 'id', clipId)
      setSvgAttr(clip, 'clipPathUnits', 'objectBoundingBox')
      this.clipRect = addSvgEl(clip, 'rect')
      setSvgAttr(this.clipRect, 'x', 0)
      setSvgAttr(this.clipRect, 'y', 0)
      setSvgAttr(this.clipRect, 'width', 1)
      setSvgAttr(this.clipRect, 'height', 0)
      setSvgAttr(this.clipRect, 'transform', 'rotate(180, 0.5, 0.5)')
    }

    for (let i = 1; i <= 17; i++) {
      let a = w * (i - 1) - (90 - w / 2)
      let gg = addSvgEl(this.svg, 'g')
      this.goalElements.push(gg)
      setSvgAttr(gg, 'class', cssPrefix + '-nav-wheel-goal ' + cssPrefix + '-nav-wheel-goal-' + i)
      setSvgAttr(gg, 'data-angle', a)
      setSvgAttr(gg, 'data-goal', i)
      if (!this.settings.showGoalsImmediately) {
        gg.style.opacity = 0
      }
      var selectable = this.settings.mode !== 'standard' && this.settings.disabledGoals.indexOf(i) === -1
      setSvgAttr(gg, 'data-maxopacity', this.settings.mode === 'standard' || selectable ? 1 : 0.1)

      gg.style.transition = 'opacity 0.3s linear ' + (i * 0.05) + 's'
      this.goals.push(gg)

      let g = addSvgEl(gg, 'g')
      setSvgAttr(g, 'transform', 'rotate(' + a + ' ' + c + ' ' + c + ')')
      setSvgAttr(g, 'fill', colors[i - 1])

      let path = addSvgEl(g, 'path')
      setSvgAttr(path, 'class', cssPrefix + '-nav-wheel-goal-slice')
      setSvgAttr(path, 'd', getSvgArc(c, r, h, w - 5))

      if (this.settings.mode !== 'standard' && this.settings.icons) {
        let image = addSvgEl(g, 'image')
        setSvgAttr(image, 'class', cssPrefix + '-nav-wheel-goal-icon')
        setSvgAttr(image, 'href', this.settings.icons[i - 1])
        setSvgAttr(image, 'width', s)
        setSvgAttr(image, 'height', s)
        setSvgAttr(image, 'x', x)
        setSvgAttr(image, 'y', y)
        setSvgAttr(image, 'transform', 'rotate(90' + ' ' + x + ' ' + y + ')')
        setSvgAttr(image, 'clip-path', 'url(#' + clipId + ')')
      }

      if (this.settings.mode !== 'standard') {
        path = addSvgEl(this.svg, 'path')
        this.goalSelectedElements.push(path)
        setSvgAttr(path, 'class', cssPrefix + '-nav-wheel-goal-selected ' + cssPrefix + '-nav-wheel-goal-selected-' + i)
        setSvgAttr(path, 'd', getSvgArc(c, r, 5, w - 7))
        setSvgAttr(path, 'transform', 'rotate(' + a + ' ' + c + ' ' + c + ')')
        setSvgAttr(path, 'fill', colors[i - 1])
        path.style.transition = 'opacity 0.3s linear ' + (i * 0.05) + 's'
        if (!this.settings.show) {
          path.style.opacity = 0
        }
      }

      gg.onclick = function (e) {
        var enabled = gg.getAttribute('data-disabled') !== 'true'
        if (enabled) {
          var id = parseInt(gg.getAttribute('data-goal'))
          var current = gg.getAttribute('data-selected') === 'true'
          if (current && self.settings.mode !== 'task') {
            self.unselectGoal(id, false)
          } else {
            self.selectGoal(id, false)
          }
        }
      }
    }

    if (this.settings.mode !== 'standard') {
      this.settings.selectedGoals.forEach(function (id) {
        self.selectGoal(id, true)
      })
    }

    return this.svg
  }

  NavWheel.prototype.unselectGoal = function (id, silent) {
    var self = this
    var g = this.goalElements[id - 1]
    if (g.getAttribute('data-selected') === 'true') {
      var a = parseFloat(g.getAttribute('data-angle'))
      var tx = this.settings.goalSelectedGap * Math.cos(a * (Math.PI / 180))
      var ty = this.settings.goalSelectedGap * Math.sin(a * (Math.PI / 180))
      setSvgAttr(g, 'data-selected', false)
      // setSvgAttr(g, 'transform', 'translate(' + 0 + ',' + 0 + ')')
      animateTranslate(g, { x: tx, y: ty }, { x: 0, y: 0 }, 0.2, function () {
        var p = self.goalSelectedElements[id - 1]
        p.style.opacity = 0
      })

      if (!silent) {
        this.trigger('unselect', g)
      }
    }
  }

  NavWheel.prototype.selectGoal = function (id, silent) {
    var g = this.goalElements[id - 1]
    if (g.getAttribute('data-selected') !== 'true') {
      var a = parseFloat(g.getAttribute('data-angle'))
      var tx = this.settings.goalSelectedGap * Math.cos(a * (Math.PI / 180))
      var ty = this.settings.goalSelectedGap * Math.sin(a * (Math.PI / 180))
      setSvgAttr(g, 'data-selected', true)
      // setSvgAttr(g, 'transform', 'translate(' + tx + ',' + ty + ')')
      animateTranslate(g, { x: 0, y: 0 }, { x: tx, y: ty }, 0.2)
      var p = this.goalSelectedElements[id - 1]
      p.style.transition = 'opacity 0.3s linear'
      p.style.opacity = 1
      if (!silent) {
        this.trigger('select', g)
      }
    }

    if (this.settings.mode === 'task') {
      for (var i = 1; i <= 17; i++) {
        if (i !== id) {
          g = this.goalElements[id - 1]
          if (g.getAttribute('data-selected') === 'true') {
            this.unselectGoal(i, silent)
          }
        }
      }
    }
  }

  NavWheel.prototype.selectGoals = function (ids) {
    for (let i = 1; i <= 17; i++) {
      let g = this.goalElements[i - 1]
      if (g.getAttribute('data-selected') === 'true' && !ids.includes(i)) {
        this.unselectGoal(i, true)
      } else if ((!g.getAttribute('data-selected') || g.getAttribute('data-selected') === 'false') && ids.includes(i)) {
        this.selectGoal(i, true)
      }
    }
  }

  NavWheel.prototype.disableGoal = function (id, silent) {
    this.unselectGoal(id, silent)
    var g = this.goalElements[id - 1]
    setSvgAttr(g, 'data-disabled', true)
    if (!silent) {
      g.style.transition = 'opacity 0.3s linear'
    }
    g.style.opacity = 0.1
  }

  NavWheel.prototype.enableGoal = function (id, silent) {
    var g = this.goalElements[id - 1]
    setSvgAttr(g, 'data-disabled', false)
    if (!silent) {
      g.style.transition = 'opacity 0.3s linear'
    }
    g.style.opacity = 1
  }

  NavWheel.prototype.enableGoals = function (goals, silent) {
    for (let i = 1; i <= 17; i++) {
      if (goals.indexOf(i) === -1) {
        this.disableGoal(i, silent)
      } else {
        this.enableGoal(i, silent)
      }
    }
  }

  NavWheel.prototype.reveal = function () {
    var self = this
    this.goals.forEach(function (goal) {
      var opacity = parseFloat(goal.getAttribute('data-maxopacity'))
      goal.style.opacity = opacity

      if (goal.getAttribute('data-selected') === 'true') {
        var goalIdx = goal.getAttribute('data-goal')
        var p = self.goalSelectedElements[goalIdx - 1]
        p.style.opacity = opacity
      }
    })
  }

  NavWheel.prototype.revealIcons = function (duration) {
    if (this.clipRect) {
      animateAttr(this.clipRect, 'height', 1, duration || 0.5)
    }
  }

  /* ResultWheel */

  var ResultWheel = function (data, options) {
    this.settings = {
      negativeSlots: 3,
      positiveSlots: 3,
      goalHeight: 30,
      targetHeight: 150,
      icons: undefined,
      disabledColor: '#bbb'
    }

    for (var key in this.settings) {
      if (options.hasOwnProperty(key)) {
        this.settings[key] = options[key]
      }
    }

    this.data = data
  }

  ResultWheel.prototype.getSvg = function () {
    var self = this

    var svg = createSvg(cssPrefix + '-result-wheel')

    var style = addSvgEl(svg, 'style')
    style.textContent = '.' + cssPrefix + '-result-wheel-target-text { fill: white; font-size: 0.7em; font-family: sans-serif; }'

    var c = size / 2
    var h = this.settings.goalHeight
    var r = c - 20 - h
    var s = (r + h) * 0.17
    var x = c - s / 2
    var y = c - r - h - s * 0.3
    var e = 3

    var circle = addSvgEl(svg, 'circle')
    setSvgAttr(circle, 'class', cssPrefix + '-result-wheel-neutral')
    setSvgAttr(circle, 'cx', c)
    setSvgAttr(circle, 'cy', c)
    setSvgAttr(circle, 'stroke-width', 3)
    setSvgAttr(circle, 'fill', 'none')
    setSvgAttr(circle, 'stroke', '#888')

    var targetCount = 0
    this.data.forEach(function (goal) {
      targetCount += goal.targets.length
    })

    var tw = (360 - e * this.data.length) / targetCount
    tw = Math.min(tw, 50)
    var th = self.settings.targetHeight / (self.settings.negativeSlots + self.settings.positiveSlots)

    setSvgAttr(circle, 'r', r - 20 - th * self.settings.positiveSlots - 2)

    e = (360 - targetCount * tw) / this.data.length

    var currentTargetCount = 0
    this.data.forEach(function (goal, gindex) {
      var w = tw * goal.targets.length
      var a = currentTargetCount * tw + gindex * e + w / 2 - 90

      var g = addSvgEl(svg, 'g')

      var path = addSvgEl(g, 'path')
      setSvgAttr(path, 'class', cssPrefix + '-result-wheel-goal-slice')
      setSvgAttr(path, 'fill', colors[goal.code - 1])
      setSvgAttr(path, 'd', getSvgArc(c, r, h, w))
      setSvgAttr(path, 'transform', 'rotate(' + a + ' ' + c + ' ' + c + ')')

      if (self.settings.icons && self.settings.icons.length >= goal.code) {
        var image = addSvgEl(g, 'image')
        setSvgAttr(image, 'class', cssPrefix + '-result-wheel-goal-icon')
        setSvgAttr(image, 'href', self.settings.icons[goal.code - 1])
        setSvgAttr(image, 'width', s)
        setSvgAttr(image, 'height', s)
        setSvgAttr(image, 'x', x)
        setSvgAttr(image, 'y', y)
        setSvgAttr(image, 'transform', 'rotate(' + (a + 90) + ' ' + c + ' ' + c + ')')
      }

      var nh = th * 2 / 3
      var tr = r - 20 - th * self.settings.positiveSlots

      goal.targets.forEach(function (target, tindex) {
        g = addSvgEl(svg, 'g')
        setSvgAttr(g, 'class', cssPrefix + '-result-wheel-target')

        var ta = a - w / 2 + tindex * tw + tw / 2

        var slices = []
        if (target.effect > 0) {
          for (var i = 1; i <= target.effect; i++) {
            slices.push({ r: tr + (i - 1) * th, h: th })
          }
        } else {
          for (i = -1; i >= target.effect; i--) {
            slices.push({ r: tr - 4 + i * nh, h: nh })
          }
        }

        slices.forEach(function (slice) {
          path = addSvgEl(g, 'path')
          setSvgAttr(path, 'stroke', 'white')
          setSvgAttr(path, 'stroke-width', 0.5)
          setSvgAttr(path, 'fill', target.disabled === true ? self.settings.disabledColor : colors[goal.code - 1])
          setSvgAttr(path, 'd', getSvgArc(c, slice.r, slice.h, tw))
          setSvgAttr(path, 'transform', 'rotate(' + ta + ' ' + c + ' ' + c + ')')
        })

        var lh = 15
        var lr = tr - lh / 2

        if (slices.length > 0) {
          lr = slices[slices.length - 1].r + th - lh / 2
          if (target.effect < 0) {
            lr = slices[0].r + nh - lh / 2
          }
        }

        path = addSvgEl(g, 'path')
        setSvgAttr(path, 'fill', target.disabled === true ? self.settings.disabledColor : colors[goal.code - 1])
        setSvgAttr(path, 'd', getSvgArc(c, lr, lh, tw * 0.7))
        setSvgAttr(path, 'transform', 'rotate(' + ta + ' ' + c + ' ' + c + ')')

        var tx = c + lr + lh / 2
        var ty = c

        var text = addSvgEl(g, 'text')
        text.textContent = goal.code + '.' + target.code
        setSvgAttr(text, 'class', cssPrefix + '-result-wheel-target-text')
        setSvgAttr(text, 'x', tx)
        setSvgAttr(text, 'y', ty)
        setSvgAttr(text, 'text-anchor', 'middle')
        setSvgAttr(text, 'dy', '.3em')
        setSvgAttr(text, 'letter-spacing', -0.5)
        setSvgAttr(text, 'transform', 'rotate(' + ta + ' ' + c + ' ' + c + ') rotate(90 ' + tx + ' ' + ty + ')')
      })

      currentTargetCount += goal.targets.length
    })

    return svg
  }

  ResultWheel.prototype.getSvgText = function () {
    var svg = this.getSvg()
    return svg.outerHTML || new XMLSerializer().serializeToString(svg)
  }

  /* ResultWheelPct */

  var ResultWheelPct = function (data, options) {
    this.settings = {
      targetHeight: 140,
      icons: undefined,
      disabledColor: '#bbb'
    }

    for (var key in this.settings) {
      if (options.hasOwnProperty(key)) {
        this.settings[key] = options[key]
      }
    }

    this.data = data
  }

  ResultWheelPct.prototype.getSvg = function () {
    var self = this

    var svg = createSvg(cssPrefix + '-result-wheel')

    var defs = addSvgEl(svg, 'defs')

    var style = addSvgEl(svg, 'style')
    style.textContent = '.' + cssPrefix + '-result-wheel-target-text { fill: #888; font-family: sans-serif; }'

    var c = size / 2
    var r = 50
    var e = 3
    var s = 30

    var circle = addSvgEl(svg, 'circle')
    setSvgAttr(circle, 'class', cssPrefix + '-result-wheel-neutral')
    setSvgAttr(circle, 'cx', c)
    setSvgAttr(circle, 'cy', c)
    setSvgAttr(circle, 'r', r)
    setSvgAttr(circle, 'stroke-width', 3)
    setSvgAttr(circle, 'fill', 'none')
    setSvgAttr(circle, 'stroke', '#888')

    var targetCount = 0
    this.data.goals.forEach(function (goal) {
      targetCount += goal.targets.length
    })

    var tw = (360 - e * this.data.goals.length) / targetCount
    tw = Math.min(tw, 50)

    var gr = c - 40
    var gh = 30

    e = (360 - targetCount * tw) / this.data.goals.length

    var labels = []

    var currentTargetCount = 0
    this.data.goals.forEach(function (goal, gindex) {
      var gw = tw * goal.targets.length
      var ga = currentTargetCount * tw + gindex * e + gw / 2 - 90

      var g = addSvgEl(svg, 'g')

      var path = addSvgEl(g, 'path')
      setSvgAttr(path, 'class', cssPrefix + '-result-wheel-goal-slice')
      setSvgAttr(path, 'fill', colors[goal.code - 1])
      setSvgAttr(path, 'd', getSvgArc(c, gr, gh, gw))
      setSvgAttr(path, 'transform', 'rotate(' + ga + ' ' + c + ' ' + c + ')')

      if (self.settings.icons && self.settings.icons.length >= goal.code) {
        var image = addSvgEl(g, 'image')
        setSvgAttr(image, 'class', cssPrefix + '-result-wheel-goal-icon')
        setSvgAttr(image, 'href', self.settings.icons[goal.code - 1])
        setSvgAttr(image, 'width', s)
        setSvgAttr(image, 'height', s)
        setSvgAttr(image, 'x', c - s / 2)
        setSvgAttr(image, 'y', c - gr - gh - s * 0.3)
        setSvgAttr(image, 'transform', 'rotate(' + (ga + 90) + ' ' + c + ' ' + c + ')')

        goal.targets.forEach(function (target, tindex) {
          var tr = r + 3
          var th = self.settings.targetHeight * target.score / 100
          var ta = ga - gw / 2 + tindex * tw + tw / 2

          g = addSvgEl(svg, 'g')
          setSvgAttr(g, 'class', cssPrefix + '-result-wheel-target')
          let title = addSvgEl(g, 'title')
          title.textContent = self.data.phase.code + '-' + target.code + ': ' + (target.negative ? '(' + target.score + '%' + ')' : target.score + '%')

          path = addSvgEl(g, 'path')
          setSvgAttr(path, 'stroke', 'white')
          setSvgAttr(path, 'stroke-width', 0.5)
          setSvgAttr(path, 'fill', target.disabled === true ? self.settings.disabledColor : colors[goal.code - 1])
          setSvgAttr(path, 'd', getSvgArc(c, tr, th, tw))
          setSvgAttr(path, 'transform', 'rotate(' + ta + ' ' + c + ' ' + c + ')')

          if (target.negative) {
            setSvgAttr(path, 'fill-opacity', 0.6)
            var dn = tw / 15
            for (let n = ta - tw / 2 + dn; n < ta + tw / 2; n += dn) {
              let point = Point.fromCircle(c, n, tr)
              path = addSvgEl(g, 'line')
              setSvgAttr(path, 'x1', point.x)
              setSvgAttr(path, 'y1', point.y)

              point = Point.fromCircle(c, n, tr + th)
              setSvgAttr(path, 'x2', point.x)
              setSvgAttr(path, 'y2', point.y)
              setSvgAttr(path, 'stroke', 'white')
              setSvgAttr(path, 'stroke-width', 0.7)
            }
          }

          var lh = 15
          var lr = tr + th - lh / 2

          labels.push({
            goal: goal.code,
            text: target.negative ? '(' + self.data.phase.code + '-' + target.code + ')' : self.data.phase.code + '-' + target.code,
            disabled: target.disabled,
            score: target.score,
            negative: target.negative,
            a: ta,
            r: lr,
            w: tw,
            h: lh
          })
        })
      }

      currentTargetCount += goal.targets.length
    })

    for (var i = 1; i <= 3; i++) {
      circle = addSvgEl(svg, 'circle')
      setSvgAttr(circle, 'class', cssPrefix + '-result-wheel-scale')
      setSvgAttr(circle, 'cx', c)
      setSvgAttr(circle, 'cy', c)
      setSvgAttr(circle, 'r', r + 3 + (i * 25 * self.settings.targetHeight / 100))
      setSvgAttr(circle, 'stroke-width', 0.5)
      setSvgAttr(circle, 'fill', 'none')
      setSvgAttr(circle, 'stroke', 'white')
    }

    labels.forEach(function (label) {
      let g = addSvgEl(svg, 'g')
      setSvgAttr(g, 'transform', 'rotate(' + label.a + ' ' + c + ' ' + c + ')')

      let id = cssPrefix + '-' + Math.random().toString(36).substr(2, 9)

      let A = Point.fromCircle(c, -label.w / 2, label.r + label.h)
      let B = Point.fromCircle(c, label.w / 2, label.r + label.h)

      let path = addSvgEl(defs, 'path')
      setSvgAttr(path, 'd', svgMoveTo(A) + svgArcTo(B, label.r + label.h, 0, 1))
      setSvgAttr(path, 'id', id)

      let text = addSvgEl(g, 'text')
      let textpath = addSvgEl(text, 'textPath')
      setSvgAttr(textpath, 'href', '#' + id)
      setSvgAttr(textpath, 'text-anchor', 'middle')
      setSvgAttr(textpath, 'startOffset', '50%')
      setSvgAttr(text, 'dy', '.3em')
      setSvgAttr(text, 'font-size', labels.length > 20 ? (0.4 + 0.3 * label.score / 100) + 'em' : '0.7em')
      setSvgAttr(textpath, 'class', cssPrefix + '-result-wheel-target-text')
      textpath.textContent = label.text
      let title = addSvgEl(text, 'title')
      title.textContent = label.text + ': ' + (label.negative ? '(' + label.score + '%' + ')' : label.score + '%')
    })

    return svg
  }

  ResultWheelPct.prototype.getSvgText = function () {
    var svg = this.getSvg()
    return svg.outerHTML || new XMLSerializer().serializeToString(svg)
  }

  /* PhaseWheel */

  var PhaseWheel = function (options) {
    this.settings = {
      select: 'none', // 'none' | 'select' | 'multi'
      colors: {
        unselectedBackground: '#bbb',
        unselectedText: '#444',
        selectedBackground: '#444',
        selectedText: 'white'
      },
      phases: []
    }

    for (var key in this.settings) {
      if (options.hasOwnProperty(key)) {
        this.settings[key] = options[key]
      }
    }

    this.callbacks = []
    this.svg = undefined
    this.events = ['select', 'unselect']
    this.phaseElements = []
    this.selectedText = undefined
  }

  PhaseWheel.prototype.on = function (event, cb) {
    var self = this

    if (!Array.isArray(event)) {
      event = [event]
    }

    event.forEach(function (e) {
      if (self.events.indexOf(e) > -1) {
        self.callbacks.push({ event: e, cb: cb })
      }
    })
  }

  PhaseWheel.prototype.trigger = function (event, data) {
    var result = true

    this.callbacks.filter(function (e) {
      return e.event === event
    }).forEach(function (value) {
      data.event = event
      var res = value.cb(data)

      if (res === undefined || res === true) {
        result = result && true
      } else {
        result = false
      }
    })

    return result
  }

  PhaseWheel.prototype.getSvg = function () {
    var self = this

    this.svg = createSvg(cssPrefix + '-phase-wheel')

    var style = addSvgEl(this.svg, 'style')
    style.textContent = '.' + cssPrefix + '-phase-wheel-text { font-size: 1em; font-family: sans-serif; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-phase { cursor: pointer; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-phase .' + cssPrefix + '-phase-wheel-text { fill: ' + this.settings.colors.unselectedText + '; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-phase[data-selected="true"] .' + cssPrefix + '-phase-wheel-text { fill: ' + this.settings.colors.selectedText + '; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-phase .' + cssPrefix + '-phase-wheel-arrow { fill: ' + this.settings.colors.unselectedBackground + '; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-phase[data-selected="true"] .' + cssPrefix + '-phase-wheel-arrow { fill: ' + this.settings.colors.selectedBackground + '; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-code { font-size: 1.7em; font-family: sans-serif; fill: #444; }'
    style.textContent += '.' + cssPrefix + '-phase-wheel-selectedtext { font-size: 1.5em; font-family: sans-serif; font-weight: bold }'

    var defs = addSvgEl(this.svg, 'defs')

    var c = size / 2
    var h = 50
    var r = c - h - 30
    var w = 360 / Math.max(this.settings.phases.length, 1)

    this.selectedText = addSvgEl(this.svg, 'text')
    setSvgAttr(this.selectedText, 'x', c)
    setSvgAttr(this.selectedText, 'y', c)
    setSvgAttr(this.selectedText, 'dy', '.3em')
    setSvgAttr(this.selectedText, 'text-anchor', 'middle')
    setSvgAttr(this.selectedText, 'class', cssPrefix + '-phase-wheel-selectedtext')

    this.settings.phases.forEach(function (phase, pindex) {
      let a = w * pindex - (180 - w / 2)

      let g = addSvgEl(self.svg, 'g')
      setSvgAttr(g, 'class', cssPrefix + '-phase-wheel-phase')
      setSvgAttr(g, 'data-phase', pindex + 1)
      let title = addSvgEl(g, 'title')
      title.textContent = phase.code + ': ' + phase.name

      setSvgAttr(g, 'data-selected', phase.selected === true)
      if (phase.selected === true && self.settings.select === 'select') {
        self.selectedText.textContent = phase.name
      }
      self.phaseElements.push(g)

      setSvgAttr(g, 'transform', 'rotate(' + a + ' ' + c + ' ' + c + ')')

      let path = addSvgEl(g, 'path')
      setSvgAttr(path, 'class', cssPrefix + '-phase-wheel-arrow')
      setSvgAttr(path, 'd', getSvgArrow(c, r, h, w - 10))

      if (self.settings.select !== 'none') {
        g.onclick = function (e) {
          var id = parseInt(g.getAttribute('data-phase'))
          var current = g.getAttribute('data-selected') === 'true'
          if (current) {
            if (self.getSelected().length > 1) {
              self.unselectPhase(id)
            }
          } else {
            if (self.settings.select === 'select') {
              self.getSelected().forEach(function (id) {
                self.unselectPhase(id)
              })
            }
            self.selectPhase(id)
          }
        }
      }

      let tr = (r + h / 2)
      let ta = (w - 15) / 2

      let A = Point.fromCircle(c, -ta, tr)
      let B = Point.fromCircle(c, ta, tr)

      var id = cssPrefix + '-' + Math.random().toString(36).substr(2, 9)
      path = addSvgEl(defs, 'path')
      setSvgAttr(path, 'd', svgMoveTo(A) + svgArcTo(B, tr, w - 15 > 180 ? 1 : 0, 1))
      setSvgAttr(path, 'id', id)

      let text = addSvgEl(g, 'text')
      let textpath = addSvgEl(text, 'textPath')
      setSvgAttr(textpath, 'href', '#' + id)
      setSvgAttr(textpath, 'text-anchor', 'middle')
      setSvgAttr(textpath, 'startOffset', '50%')
      setSvgAttr(text, 'dy', '.3em')
      setSvgAttr(textpath, 'class', cssPrefix + '-phase-wheel-text')
      textpath.textContent = phase.name

      A = Point.fromCircle(c, a, r + h + 20)
      text = addSvgEl(self.svg, 'text')
      setSvgAttr(text, 'x', A.x)
      setSvgAttr(text, 'y', A.y)
      setSvgAttr(text, 'text-anchor', 'middle')
      setSvgAttr(text, 'dy', '.3em')
      setSvgAttr(text, 'class', cssPrefix + '-phase-wheel-code')
      text.textContent = phase.code
    })

    return this.svg
  }

  PhaseWheel.prototype.unselectPhase = function (id) {
    var g = this.phaseElements[id - 1]
    if (g.getAttribute('data-selected') === 'true') {
      setSvgAttr(g, 'data-selected', false)
      this.trigger('unselect', { phase: id })
    }
  }

  PhaseWheel.prototype.selectPhase = function (id) {
    var g = this.phaseElements[id - 1]
    if (g.getAttribute('data-selected') !== 'true') {
      setSvgAttr(g, 'data-selected', true)
      this.trigger('select', { phase: id })
    }

    if (this.settings.select === 'select') {
      this.selectedText.textContent = this.settings.phases[id - 1].name
    }
  }

  PhaseWheel.prototype.getSelected = function () {
    return this.phaseElements.filter(function (el) {
      return el.getAttribute('data-selected') === 'true'
    }).map(function (el) {
      return parseInt(el.getAttribute('data-phase'))
    })
  }

  /* CompletedPct */

  var CompletedPct = function (options) {
    this.settings = {
      scaleHeight: 45,
      markerRadius: 60,
      // negative parameter
      negative: false,
      colors: {
        uncompleted: '#bbb',
        completed: 'skyblue'
      }
    }

    for (var key in this.settings) {
      if (options && options.hasOwnProperty(key)) {
        this.settings[key] = options[key]
      }
    }

    this.svg = undefined
  }

  CompletedPct.prototype.getSvg = function (pct) {
    this.svg = createSvg(cssPrefix + '-completed-pct', 500, this.settings.markerRadius * 2)

    var scaleLeft = this.settings.scaleHeight / 2 + 3
    var scaleRight = 500 - this.settings.scaleHeight / 2 - 3

    var markerLeft = this.settings.markerRadius + 3
    var markerRight = 500 - this.settings.markerRadius - 3
    var markerWidth = markerRight - markerLeft
    var markerPos = markerLeft + markerWidth * pct / 100

    var A = new Point(markerPos, this.settings.markerRadius - this.settings.scaleHeight / 2)
    var B = new Point(scaleLeft, this.settings.markerRadius - this.settings.scaleHeight / 2)
    var C = new Point(scaleLeft, this.settings.markerRadius + this.settings.scaleHeight / 2)
    var D = new Point(markerPos, this.settings.markerRadius + this.settings.scaleHeight / 2)

    var E = new Point(scaleRight, this.settings.markerRadius - this.settings.scaleHeight / 2)
    var F = new Point(scaleRight, this.settings.markerRadius + this.settings.scaleHeight / 2)

    var p = addSvgEl(this.svg, 'path')
    setSvgAttr(p, 'd', svgMoveTo(A) + svgLineTo(B) + svgArcTo(C, this.settings.scaleHeight / 2, 0, 0) + svgLineTo(D) + 'Z')
    setSvgAttr(p, 'fill', this.settings.negative ? this.settings.colors.uncompleted : this.settings.colors.completed)

    p = addSvgEl(this.svg, 'path')
    setSvgAttr(p, 'd', svgMoveTo(A) + svgLineTo(E) + svgArcTo(F, this.settings.scaleHeight / 2, 0, 1) + svgLineTo(D) + 'Z')
    setSvgAttr(p, 'fill', this.settings.negative ? this.settings.colors.completed : this.settings.colors.uncompleted)

    var circle = addSvgEl(this.svg, 'circle')
    setSvgAttr(circle, 'fill', this.settings.colors.completed)
    setSvgAttr(circle, 'cx', markerPos)
    setSvgAttr(circle, 'cy', '50%')
    setSvgAttr(circle, 'r', this.settings.markerRadius)
    setSvgAttr(circle, 'stroke', '#fff')
    setSvgAttr(circle, 'stroke-width', '6')

    return this.svg
  }

  CompletedPct.prototype.getSvgText = function (percent) {
    var svg = this.getSvg(percent)
    return svg.outerHTML || new XMLSerializer().serializeToString(svg)
  }

  return {
    Nav: NavWheel,
    Result: ResultWheel,
    ResultPct: ResultWheelPct,
    Phase: PhaseWheel,
    CompletedPct: CompletedPct
  }
})()

export default SdgWheels
